const fallbackStoreUrl = 'https://novomins.com';

export const storeUrl = typeof window !== 'undefined' && window.location.origin
	? window.location.origin
	: fallbackStoreUrl;
export const apiUrl = `${storeUrl}/api/2024-01/graphql.json`;
export const storefrontAccessToken = 'c689a12d8629792c990c6a7ac8a24493';

